import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Group } from '@era/security-sdk';
import { UserGroupStoreActions, UserGroupStoreSelectors, UserStoreSelectors } from '@era/stores';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { AddMemberModalComponent } from '../../groups/add-member-modal/add-member-modal.component';
import { MemberShipListComponent } from './membership-list.component';

@Component({
  selector: 'era-security-membership-list',
  templateUrl: './membership-list.container.html',
  styleUrls: ['./membership-list.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MemberShipListComponent],
})
export class MembershipListContainerComponent {
  private readonly store = inject(Store);
  private readonly modalService = inject(NgbModal);

  public readonly user = this.store.selectSignal(UserStoreSelectors.selectCurrentUser);
  public editEnabled = false;

  toggleEditEvent(): void {
    this.editEnabled = !this.editEnabled;
  }

  addGroupEvent() {
    const modelRef = this.modalService.open(AddMemberModalComponent);
    this.store
      .select(UserGroupStoreSelectors.selectAllPossibleMemberships)
      .pipe(
        filter((x: Group[]) => x.length > 0),
        take(1)
      )
      .subscribe((x) => {
        if (modelRef.componentInstance) {
          modelRef.componentInstance.items = x;
        }
      });

    modelRef.result.then(
      (result: Group) => {
        const currentUser = this.user();

        if (!currentUser) {
          return;
        }

        this.store.dispatch(
          UserGroupStoreActions.MembershipListUIActions.userGroupAdded({
            group: result,
            userToAdd: currentUser,
          })
        );
      },
      () => {
        return;
      }
    );
  }
}
